import React, { Component } from 'react'
import { Layout, Typography, Row, Col, Button, Card, Carousel, message, Icon, Tag, Tooltip, Spin, Input, Popconfirm } from 'antd';

class ReplyComment extends Component {
  constructor(props) {
    super(props)

    this.state = {
      liked: false
    }
  }

  toggleLike = () => {
    let { liked } = this.state
    this.setState({
      liked: !liked
    })
  }

  render() {
    const { liked } = this.state

    return (
      <div className="reply-comment">
        <Row>
          <Col lg={2} className="comment-img">
            <img src="/img/user.png" alt="" />
          </Col>
          <Col lg={22} className="comment-details">
            <h6 className="name">Terry Pham</h6>
            <span>
              <Icon type="clock-circle" className="clock-icon" />
              3 hours ago
          </span>
            <span className="no-likes">
              <Icon type="like" theme="filled" /> 2
          </span>
            <p className="comment-writeup">
              simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
          </p>
            <div className="actions">
              {
                liked ? <Button onClick={() => this.toggleLike()}>
                  Unlike
              <i className="far fa-thumbs-down custom-icon"></i>
                </Button> : <Button onClick={() => this.toggleLike()}>
                    Like
              <Icon type="like" theme="filled" />
                  </Button>
              }
              <Popconfirm
                title="Are you sure you want to delete your reply?"
                // onConfirm={}
                // onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <Button>
                  Delete
              <Icon type="delete" theme="filled" />
                </Button>
              </Popconfirm>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default ReplyComment
